export class Permissions {
  static ALPHA_ACCESS = 'include-feature:alpha-access';
  static ALPHA_ACCESS_COMMODITIES = 'include-feature:alpha-access:commodities';
  static ALPHA_ACCESS_MARKET_SIGNALS = 'include-feature:alpha-access:market-signals';
  static ALPHA_ACCESS_CHAT = 'include-feature:alpha-access:chat';
  static ALPHA_ACCESS_DATA = 'include-feature:alpha-access:data';
  static BETA_ACCESS = 'include-feature:beta-access';
  static EXCLUDE_NEWS = 'exclude-feature:news-content';
  static ANY_SELECT_PRODUCT = /read:select:.*/;
  static ANY_ALPHA_ACCESS = /^include-feature:alpha-access(:.*)?$/;
  static PETRO_PIPELINES = 'read:petro-pipelines';
  static PETRO_PIPELINES_PLUS = 'read:petro-pipelines-plus';
  static HSC_PACKAGE = 'client:package:hsc';
  static EXCEL_PACKAGE = 'client:package:datalink';
  static NOTIFICATIONS = 'include-feature:notifications';
  static DEEP_DIVE_ACCESS = 'include-feature:deepdive';
  static COPY_NEWS_FEED = 'copy:news-feed';

  static ANY_ALPHA_OR_PETRO = /^(?:include-feature:alpha-access(:.*)?|read:petro-pipelines-plus)$/; // temporary
}
